import QuestionViewer from './GeneralQuestionViewer';
import GeneralQuestionEditor from './GeneralQuestionEditor';

export const GeneralQuestionViewer = QuestionViewer;
export default GeneralQuestionEditor;
